import { render, staticRenderFns } from "./TagsSetting.vue?vue&type=template&id=44cd3fda&scoped=true"
import script from "./TagsSetting.vue?vue&type=script&lang=js"
export * from "./TagsSetting.vue?vue&type=script&lang=js"
import style0 from "./TagsSetting.vue?vue&type=style&index=0&id=44cd3fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd3fda",
  null
  
)

export default component.exports